import React, { useState } from "react";
import { Pencil, Check, X } from "lucide-react";
import { translations } from "../../../translations/translations";

interface Props {
    waveNumber: 1 | 2  | 3 | 4 ;
    amount: number;
    onSave: (amount: number) => void | Promise<void>;
    frequency: string;
    language: "en" | "es";
  }

export const EditableWaveAmount: React.FC<Props> = ({
  //waveNumber,
  amount,
  onSave,
 // frequency,
  language,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(amount.toString());
  const [isSaving, setIsSaving] = useState(false);
  const t = translations[language];

  const handleSave = async () => {
    const numValue = parseFloat(value);
    if (isNaN(numValue) || numValue < 0) {
      alert(t.editableWave.invalidAmount);
      return;
    }
    setIsSaving(true);
    try {
      await onSave(numValue);
      setIsEditing(false);
    } catch (error) {
      alert(t.editableWave.failedToSave);
    } finally {
      setIsSaving(false);
    }
  };
  const handleCancel = () => {
    setValue(amount.toString());
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div className="flex items-center gap-2">
        <input
          type="number"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="w-24 px-3 py-1.5 bg-white/10 border border-white/20 rounded-lg text-white text-sm outline-none focus:border-primary"
          autoFocus
          disabled={isSaving}
        />
        <div className="flex gap-1">
          <button
            className="p-1.5 bg-transparent border-none text-green-400 hover:bg-white/10 rounded-md cursor-pointer disabled:opacity-50"
            onClick={handleSave}
            disabled={isSaving}
            aria-label="Save"
          >
            <Check size={18} />
          </button>
          <button
            className="p-1.5 bg-transparent border-none text-red-400 hover:bg-white/10 rounded-md cursor-pointer disabled:opacity-50"
            onClick={handleCancel}
            disabled={isSaving}
            aria-label="Cancel"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-white font-semibold">${amount.toFixed(2)}</span>
      <button
        className="p-1 bg-transparent border-none text-muted hover:text-white hover:bg-white/10 rounded-md cursor-pointer"
        onClick={() => setIsEditing(true)}
        aria-label="Edit"
      >
        <Pencil size={18} />
      </button>
    </div>
  );
};